import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from '../../components/Popup/popup';
import { Dropdown } from 'components/Dropdown/Dropdown';
const popUpStyle = {width: 350, height: 145, right: 330, top: -10};
export class EditContactInformationPopup extends Component {
    static propTypes = {
      onClose: PropTypes.func,
      ContactInformationList: PropTypes.array,
      onEditContactInformation: PropTypes.func,
      onGetNewContactInformation: PropTypes.func,
      contactInformationChange: PropTypes.object,
      onFetchContactInformation: PropTypes.func
    }

    constructor(props) {
      super(props);

      this.state = {
        contactInfoValue: this.props.contactInformationChange
      };
    }
    onClose = () => {
      this.props.onClose();
    }

    onFetchContactInformation = () => {
      this.setState({
        isLoadingContactInfo: true
      }, () => this.props.onFetchContactInformation(() => this.setState({isLoadingContactInfo: false})))
      ;
    }

    onSave = () => {
      this.props.onClose(() => {
        this.props.onEditContactInformation({
          PrioritizedContactId: this.state.contactInfoValue.value
        }, () => this.props.onGetNewContactInformation());
      });
    }

    onChange = (event) => {
      this.setState({
        contactInfoValue: event.value
      });
    }
    customRender = (fullName, email) => {
      return (
        <React.Fragment>
          <div>
            <span style={{fontSize: 14}}>{fullName}</span>
          </div>
          <div>
            <span style={{fontSize: 13}}>{email}</span>
          </div>
        </React.Fragment>
      );
    }

    render() {
      const optionsValue = this.props.ContactInformationList.map(x => ({
        text: this.customRender(x.fullName, x.email),
        value: x.id
      }));
      return (
        <Popup
          className='edit-contact-info-rfs'
          //   isHasFaded={true}
          styles={popUpStyle}
          ref={ref => {
            this.popup = ref;}}>
          <div className='edit-contact-information container-fluid'>
            <h5 style={{margin: '0px 0px 15px'}}>Contact Information <span className='text-danger'>*</span></h5>
            <Dropdown
              onChange={this.onChange}
              className='filestring-dropdown filter-dropdown'
              value={this.state.contactInfoValue}
              onRemote={this.onFetchContactInformation}
              options={ optionsValue }
              style={{width: '100%'}}
              optionLabel='text'
              loading={this.state.isLoadingContactInfo}
              // filter={true}
              placeholder='Select Any'
              errorMessage='This information is required.'
              ref={ref => {
                this.contactInfo = ref;
              }} />
            <div className='row'>
              <button style={{marginLeft: 15}} onClick={this.onClose} className='btn btn-siteone-default'>Cancel</button>
              <button onClick={this.onSave} className= 'btn-submit btn btn-primary btn-siteone'>Save</button>
            </div>
          </div>
        </Popup>
      );
    }
}

export default EditContactInformationPopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/EditContactInformationPopup.js